// **********************************************************************
// ******** Agenda do Prestador ***
// ******** app/PrestadorProfileprestador/agendamento.jsx
// ******** autor: WdePaula / Microvolution
// ******** data: 08/11/24 | 16h21 | criação da página com base na página "agendamento.jsx"
// ******** Agenda do Prestador ***
// **********************************************************************


import React, { useState, useEffect, useRef } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Icon from '@mdi/react';
import { mdiArrowLeftCircle } from '@mdi/js';
import apiaxios from '../../../../Services/apiaxios.js';
import handleApiError from '../../../../Services/apiErrorHandler.js';
import CardCalendario from '../../components/Calendario/calendario.jsx';
import CardHorarios from '../../components/Calendario/horarios.jsx';
import CardUserInputModalPrestador from '../../components/Agendamentos/userinputmodalprestador.jsx';
import DownloadAppModal from '../../components/Agendamentos/modaldownload.jsx'
import imgLogomarca from '../../../../Assets/agendex/logoagendexcliente.png';
import imgLogoMini from '../../../../Assets/agendex/iconLogoAgendex.png';
import Footer from '../../components/Footer/footer.jsx';

import './prestadoragendamento.css';
import { Spinner } from 'react-bootstrap';

function PrestadorAgendamento () {
    const { state } = useLocation();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const { linkpersonalizado, id, servId } = useParams();
    const [horarios, setHorarios] = useState([]);
    const [fotoPerfil, setFotoPerfil] = useState(state?.fotoPerfil || null);
    const [vINTERVALOAGENDA, setVINTERVALOAGENDA] = useState(state?.intervaloAgendamento || 60); // Default value
    const [empresaNome, setEmpresaNome] = useState(state?.nomeEmpresa || null);
    const [empresaEndereco, setEmpresaEndereco] = useState(state?.enderecoEmpresa || null);
    const [empresaCelular, setEmpresaCelular] = useState(state?.celularEmpresa || null);
    const [servicoNome, setServicoNome] = useState(state?.servicoNome || null);
    const [servicoValor, setServicoValor] =  useState(state?.servicoValor || null);

    const [servicoDataHora, setServicoDataHora] = useState(null);
    const [selectedHorario, setSelectedHorario] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [celular, setCelular] = useState('');
    const [nome, setNome] = useState('');
    const [obs, setObs] = useState('');
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [resId, setResId] = useState(0);
    const [idUsuarioAnonimo, setIdUsuarioAnonimo] = useState(0);

    const [loadingHorarios, setLoadingHorarios] = useState(false);

    const horariosRef = useRef(null);  // Ref para a seção de horários
    const navigate = useNavigate();

    // verifica se é mobile, tablet, NB, PC, etc
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Monitoramos `selectedHorario` para atualizar `servicoDataHora` quando ele mudar
    useEffect(() => {
        if (selectedHorario) {
            setServicoDataHora(selectedHorario.DATA_HORA);
            // console.log('servicoDataHora atualizado no useEffect: ', selectedHorario.DATA_HORA);
        }
    }, [selectedHorario]); // Este efeito é executado sempre que `selectedHorario` mudar

    const fetchHorarios = (date) => {
        if (!date) return; // Evita requisições desnecessárias se a data for nula

        const formattedDate = date.toISOString().split('T')[0];
        const endpoint = `/servico/HorarioGlobalDiario`; // rota desprotegida - sem token jwt

        const params = {
            id_usuario: id,
            id_servico: servId,
            dt: formattedDate,
            tempoAgendaMinutos: vINTERVALOAGENDA
        };
        
        setHorarios([]);
        setLoadingHorarios(true);
        apiaxios.get(endpoint, { params })
            .then(response => {
                setHorarios([]);
                const horariosDisponiveis = response.data.map(item => ({
                    ...item,
                    selected: false,
                    label: item.label || item.HORA // Assegurar que existe uma propriedade para exibição
                }));
                setHorarios(horariosDisponiveis);
                // setHorarios(['carregando horários']);
                horariosRef.current.scrollIntoView({ behavior: 'smooth' });  // Scroll para a seção de horários
            })
            .catch(error => {
                handleApiError(error);
                // console.error(error);
                setHorarios([]);
            })
            .finally( e => {
                setLoadingHorarios(false);
            })
    };

    const handleSelectDate = (date) => {
        // console.log('idservico : ', servId);
        fetchHorarios(date);
        setSelectedHorario(null); // limpa o horário selecionado e oculta o botão "Confirmar Agendamento"
        // horariosRef.current.scrollIntoView({ behavior: 'smooth' });  // Scroll para a seção de horários
    };

    const onSelectHorario = async (horaSelecionada) => {
        const updatedHorarios = horarios.map(hora => ({
            ...hora,
            selected: hora.HORA === horaSelecionada.HORA
        }));
        setHorarios(updatedHorarios);
        setSelectedHorario(horaSelecionada);
    };

    // Função para formatar a data
    const formatarData = (data) => {
        const partes = data.split('/');
        return `${partes[2]}/${partes[1]}/${partes[0]}`;
    };

    // const onConfirmaAgendamento = () => {

    //     if (!selectedHorario) {
    //         Swal.fire('Erro', 'Você precisa marcar um dia e horário para confirmar agendamento', 'error');
    //         return;
    //     }

    //     Swal.fire({
    //         title: 'Confirmação!',
    //         text: `Você confirma este agendamento no Agendex Cliente Web?`,
    //         icon: 'question',
    //         showCancelButton: true,
    //         confirmButtonColor: '#3085d6',
    //         cancelButtonColor: '#d33',
    //         confirmButtonText: 'Sim, agendar!',
    //         cancelButtonText: 'Cancelar'
    //       }).then((result) => {
    //         if (result.isConfirmed) {
    //             const checkAgendaFechada = async () => {
    //                 try {
    //                     // alert('agendafechadafetch');
    //                     // const response = await apiaxios.get('/Empresa/AgendaFechadaWeb', { // modificada pela linha abaixo 30/12/24w
    //                     const response = await apiaxios.get('/EmpresaLink/empresaAgendaFechadaWeb', {
    //                         params: { id_usuario: id }
    //                     });
        
    //                     if (response.status === 200) {
    //                         const data = response.data;
    //                         if (data.retorno !== 'OK') {
    //                             Swal.fire('Erro', data.retorno, 'error');
    //                             return false;
    //                         }
        
    //                         const agendaFechada = data.agenda_fechada === null ? 0 : data.agenda_fechada;

    //                         if (agendaFechada === 1) {
    //                             Swal.fire('Empresa com Agenda fechada temporariamente!', '', 'info');
    //                             return false;
    //                         }
    //                         return true;
    //                     } else {
    //                         Swal.fire('Erro', 'Falha ao verificar o status da agenda do profissional escolhido. Tente novamente mais tarde.', 'error');
    //                         return false;
    //                     }
    //                 } catch (error) {
    //                     Swal.fire('Erro', 'Erro ao verificar o status da agenda: ' + error.message, 'error');
    //                     return false;
    //                 }
    //             };
        
    //             setShowModal(true); // removido 20/7/24w 13h18 // voltei 20/7/24w 13h28
    //         }
    //       });
    // };
    const onConfirmaAgendamento = async () => {
        if (!selectedHorario) {
            Swal.fire('Erro', 'Você precisa marcar um dia e horário para confirmar agendamento', 'error');
            return;
        }
    
        const result = await Swal.fire({
            title: 'Confirmação!',
            text: `Você confirma este agendamento no Agendex Cliente Web?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, agendar!',
            cancelButtonText: 'Cancelar'
        });
    
        if (result.isConfirmed) {
            const checkAgendaFechada = async () => {
                try {
                    // console.log('agendafechadafetch');
                    const response = await apiaxios.get('/empresaLink/EmpresaAgendaFechadaWeb', {
                        params: { id_usuario: id }
                    });
    
                    if (response.status === 200) {
                        const data = response.data;
                        // console.log('response dada: ', data);
                        if (data.retorno !== 'OK') {
                            Swal.fire('Erro', data.retorno, 'error');
                            return false;
                        }
    
                        const agendaFechada = Number(data.agenda_fechada === null ? 0 : data.agenda_fechada);
                        // console.log('agendaFechada ', agendaFechada);
                        if (agendaFechada === 1) {
                            Swal.fire('Empresa com Agenda fechada temporariamente!', '', 'info');
                            return false;
                        }
                        return true;
                    } else {
                        Swal.fire('Erro', 'Falha ao verificar o status da agenda do profissional escolhido. Tente novamente mais tarde.', 'error');
                        return false;
                    }
                } catch (error) {
                    Swal.fire('Erro', 'Erro ao verificar o status da agenda: ' + error.message, 'error');
                    return false;
                }
            };
    
            // Aguarda a verificação da agenda antes de executar o próximo passo
            const isAgendaAberta = await checkAgendaFechada();
            // console.log('isAgendaAberta ', isAgendaAberta);
            if (isAgendaAberta) {
                setShowModal(true); // Só será executado se a agenda não estiver fechada
            }
        }
    };

    const handleBackClick = () => {
        navigate(-1); // Navegar para a página anterior
    };

    const handleClose = () => {
        setShowModal(false);
    };
    
    const handleSave = (data) => {
        const clienteNome = data.nome;
        const clienteFone = data.celular;
        setCelular(data.celular);
        setNome(data.nome);
        // console.log('data ', data);
        // console.log('nome cliente ', nome);
        // console.log('celular cliente ', celular);
        // console.log('data.nome ', data.nome);
        // console.log('data.celular ', data.celular);
        // setObs(data.obs);
        // setUserData({ celular: data.celular, nome: data.nome, obs: data.obs });
    
        setShowModal(false);
        const agendarServico = async () => {
            const dataFormatada = formatarData(selectedHorario.DATA);

            try {
                // const response = await apiaxios.post('/servico/agendar', {
                const response = await apiaxios.post('/empresaLink/ServicoAgendarPrestadorWeb', {
                    id_usuario: id, // Supondo que `id_usuario` seria por hora o do prestador`
                    id_servico: servId,
                    id_empresa: id,
                    dt: dataFormatada, // Usando a data formatada
                    hora: selectedHorario.label,
                    id_status: 1,
                    agenda_avulso_nome: data.nome,
                    agenda_avulso_fone: data.celular,
                    agenda_avulso_obs: data.obs
                });

                if (response.status === 201) {
                    const data = response.data;
                    if (data.retorno === 'OK') {
                        Swal.fire('Sucesso', `Agendamento nº ${data.id_reserva} realizado com sucesso!`, 'success').then(() => {
                            // console.log('🔍 Antes de chamar handleAgendamentoSuccess');
                            // console.log('📱 Dados:', {
                            //     hora: selectedHorario.label,
                            //     data: selectedHorario.DATA,
                            //     nome: clienteNome,
                            //     fone: clienteFone,
                            //     id: response.data.id_reserva
                            // });

                            setResId(data.id_reserva);
                            setIdUsuarioAnonimo(data.id_usuario_anonimo);
                            handleAgendamentoSuccess(
                                selectedHorario.label,
                                selectedHorario.DATA,
                                clienteNome,
                                clienteFone,
                                data.id_usuario_anonimo,
                                data.id_reserva
                            );
                        });
                    } else {
                        Swal.fire('Erro', data.retorno, 'error');
                    }
                } else {
                    Swal.fire('Erro', 'Falha ao confirmar agendamento. Tente novamente mais tarde.', 'error');
                }
            } catch (error) {
                Swal.fire('Erro', 'Erro ao confirmar agendamento: ' + error.message, 'error');
            }
        };
        agendarServico();
    }

    // const handleAgendamentoSuccess = (servicoId, servicoHorario, servicoData, nomeCliente, celularCliente) => {
    // const handleAgendamentoSuccess = (servicoHorario, servicoData, nomeCliente, celularCliente ) => {
    const handleAgendamentoSuccess = (
        servicoHorario, 
        servicoData, 
        nomeCliente, 
        celularCliente, 
        usuarioanonimo, 
        idreserva ) => {
        // console.log('handleAgendamentoSuccess clienteNome ', nomeCliente);
        // console.log('handleAgendamentoSuccess clienteFone ', celularCliente);
        // console.log('servicoData ', servicoData);
        // console.log('🚀 handleAgendamentoSuccess chamada!');
        // console.log('📍 Vai navegar para:', `/agendar/${linkpersonalizado}/${id}/servico/${servId}/agendamento/${resId}`);
        setShowDownloadModal(true);
        navigate(`/agendar/${linkpersonalizado}/${id}/servico/${servId}/agendamento/${resId}`, {
            state: { 
                empresaNome, 
                empresaEndereco, 
                servicoNome, 
                servicoHorario, 
                servicoData, 
                servicoValor,
                fotoPerfil, 
                nomeCliente, 
                celularCliente,
                empresaCelular,
                idreserva, // acrescentado 30/12/24w pra poder excluir a reserva se o cliente quiser
                id, // acrscentado 30/12/24w pra enviar o id_usuario pra poder excluir a reserva se o cliente quiser
                usuarioanonimo // acrescentado 30/12/24w pra enviar o id_usuario_anonimo pra poder excluir a reserva se o cliente quiser
            }
        });
    };




    return (
        <>
            <div className="container-fluid">
                <div className="row flex-nowrap">
                    <div className="col py-3 me-3 main-content">
                        <div className="text-center">
                            <button className="btn btn-secondary back-button position-fixed top-0 start-0 m-3" onClick={handleBackClick}>
                                <Icon path={mdiArrowLeftCircle} size={1}/> {!isMobile && 'Voltar'}
                            </button>
                            <img src={isMobile ? imgLogoMini : imgLogomarca} className={`img-logo ${isMobile ? 'img-logo-mobile' : 'img-logo-desktop'}`} alt="logo agendex"/>
                            <br/>

                            {fotoPerfil ? (
                                <div className='text-center'>
                                    <img src={fotoPerfil} alt="Imagem de capa do Prestador" className='usuario-foto'/>
                                </div>
                            ) : (
                                <p>{empresaNome}</p>                                        
                            )}

                            <br/> <br/>
                        </div>
                        <hr />
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className='box-detalhe-agenda'>
                                <CardCalendario onSelectDate={handleSelectDate} />
                                <hr />
                            </div>
                        </div> 
                        
                        <div ref={horariosRef} className="box-colaboradores">
                            {loadingHorarios ? (
                                <div className="text-center">
                                    <Spinner animation="border" role="status">
                                        <span className="visually-hidden">Carregando...</span>
                                    </Spinner>
                                </div>
                                ) : (
                                    <CardHorarios horarios={horarios} onSelectHorario={onSelectHorario}/>
                                )}
                            <hr />
                            <br />
                            <div className="text-center">
                                <button 
                                    type="button" 
                                    className="btn btn-success"
                                    disabled={!selectedHorario} // Botão desativado enquanto não há horário selecionado
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title='O dia/horário acima foi selecionado. Clique para confirmar seu agendamento!'
                                    onClick={() => onConfirmaAgendamento()}
                                >
                                    Confirmar Agendamento
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>

            <div>
                {/* <button onClick={onConfirmaAgendamento}></button> */}
                <CardUserInputModalPrestador
                    show={showModal}
                    onHide={handleClose}
                    handleSave={handleSave}
                    celular={celular}
                    setCelular={setCelular}
                    nome={nome}
                    setNome={setNome}
                    obs={obs}
                    setObs={setObs}
                    servicoNome={servicoNome}
                    servicoValor={servicoValor}
                    servicoDataHora={servicoDataHora}
                />
            </div>
            <div>
                <DownloadAppModal
                    show={showDownloadModal}
                    onHide={() => setShowDownloadModal(false)}
                />
            </div>
        </>
    );
}

export default PrestadorAgendamento;